const dialogueList = [
    {
        id: 0,
        question: "I know it walks like a duck.. it quacks like a duck! So it must be a ... ehhhrm.. help me out here buddy!",
        awnser: "duck"
    },
    {
        id: 1,
        question: "It lays eggs and they sell it deep fried at Kentucky fried ... Dang, what's that animal called again?",
        awnser: "chicken"
    },
    {
        id: 2,
        question: "You got to grab the ... ehh.. something by the horns.",
        awnser: "bull"
    },
    {
        id: 3,
        question: "I always count them when i want to fall asleep. Shucks, this animal had a really difficult name.",
        awnser: "sheep"
    },
    {
        id: 4,
        question: "It loves to roll around in the mud. Come to think of it this animal reminds me of my wife! Let's keep that between you and me.",
        awnser: "pig"
    },
    {
        id: 5,
        question: "This animal makes a sound like 'MooOOOooO!!!'. Do you know what it's called?",
        awnser: "cow"
    },
    {
        id: 6,
        question: "It eats carrots and you can ride it!",
        awnser: "horse"
    },
    {
        id: 7,
        question: "This animal has horns and a beard. It's crazy i tell ya! now what's it called again?",
        awnser: "goat"
    },
    {
        id: 8,
        question: "It looks somewhat like a hog, but it's not a hog!",
        awnser: "pig"
    },
    {
        id: 9,
        question: "Man i used to yank on them udders until i got a big ol' bucket full of milk! I can't believe i forgot this animals name.. i drank ALL the MILK! good times.",
        awnser: "cow"
    },
    {
        id: 10,
        question: "I once wore my favorite red overall and this animal came charging at me! Do you know what type of animal i'm talking about now?",
        awnser: "bull"
    }
];

export default dialogueList;